import type { IconSvgObject } from './types';

const ZodiacTaurusIcon: IconSvgObject = [
  ["circle", { cx: "12", cy: "15", r: "6", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M18 3C18 6.31371 15.3137 9 12 9C8.68629 9 6 6.31371 6 3", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }]
];

export default ZodiacTaurusIcon;
